// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__39zQp","overflowing":"ReadFullNote_overflowing__Yu1Gq"};